export default __webpack_public_path__ + "static/media/photo--lg--14.a1cab836.jpg";